module.exports = "../assets/sold-placeholder.7c7ca34e.png";